import React, { Component } from 'react'
import DiscountCol from '../widgets/DailyDiscounts/StyledDiscountCol'
import DiscountImage from './images/DiscountImage'
import DiscountLink from '../widgets/DailyDiscounts/StyledDiscountLink'
import MoreButtonTitle from './titles/MoreButtonTitle'
import { type DiscountBoxProps } from './Types'

export default class DiscountBox extends Component<DiscountBoxProps> {
  componentDidMount () {
    const {
      googleAnalytics,
      guid: id,
      position,
      section: category,
      title: name
    } = this.props

    if (googleAnalytics) {
      const impressionFieldObject = {
        id,
        name,
        category,
        list: 'slevydne',
        position
      }

      googleAnalytics.addImpression(impressionFieldObject)
    }
  }

  handleAnchorClick (event, location) {
    const {
      googleAnalytics,
      guid: id,
      section: category,
      title: name
    } = this.props

    if (googleAnalytics) {
      event.preventDefault()

      const purchaseFieldObject = {
        id,
        name,
        category
      }

      googleAnalytics.handlePurchaseEvent(purchaseFieldObject).then(() => {
        document.location.href = location
      }).catch(() => {
        document.location.href = location
      })
    }
  }

  render () {
    const {
      discount,
      image,
      imageClass,
      link,
      price,
      title
    } = this.props

    const formattedPrice = (typeof Intl === 'object' && Intl && typeof Intl.NumberFormat === 'function')
      ? Math.floor(price).toLocaleString('cs-CZ')
      : Math.floor(price)

    return (
      <DiscountCol>
        <DiscountLink href={link} onClick={event => this.handleAnchorClick(event, link)}>
          <DiscountImage discount={discount} image={image} imageClass={imageClass} title={title}/>
          <MoreButtonTitle price={typeof price === 'string' ? price : formattedPrice} title={title}/>
        </DiscountLink>
      </DiscountCol>
    )
  }
}
